import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { cargar, seguimiento } from "../carga";

// «Todas las obras» usa la vista resumida (título, fechas extremas y número de funciones): con ~1500 obras,
// la respuesta completa pesaba ~2 MB. La ficha completa se pide al abrir cada obra.
export const fetchObrasList = createAsyncThunk("Obras/fetchObrasList", () => cargar('obras?vista=resumen'));

export const fetchObrasNow = createAsyncThunk("Obras/fetchObrasNow", () => cargar('obras/now'));

export const fetchObrasMes = createAsyncThunk("Obras/fetchObrasMes", aniomes => cargar(`obras/${aniomes}`));

export const fetchObra = createAsyncThunk("Obras/fetchObra", id => cargar(`obras/${id}`));

export const ObrasSlice = createSlice({
  name: "Obras",
  initialState: {
    ObrasList: [],
    listMes: [],
    listNow: [],
    loading: false,
    error: null,
    obra: {},
  },
  reducers: {
    sortCreacionNew: (state) => {
      state.ObrasList.sort((a, b) => (a.creacion < b.creacion) ? 1 : -1)
    },
    sortCreacionOld: (state) => {
      state.ObrasList.sort((a, b) => (a.creacion > b.creacion) ? 1 : -1)
    },
  },
  extraReducers: builder => {
    seguimiento(builder, fetchObra, 'obra');
    seguimiento(builder, fetchObrasList, 'ObrasList');
    seguimiento(builder, fetchObrasMes, 'listMes');
    seguimiento(builder, fetchObrasNow, 'listNow');
  },
});

export const {sortCreacionNew, sortCreacionOld} = ObrasSlice.actions;

export const selector = (state) => state.obras;

export default ObrasSlice.reducer;
